module.exports = __webpack_public_path__ + "static/media/DESTINATION-WEDDINGS-IN-PORTUGAL-MAIN-BUILDING-BY-NIGHT-.90a43b9f.jpg";